import styled from 'styled-components'

import colors from '@settings/styleSettings'
import Modal from 'styled-react-modal'

export const Container = Modal.styled`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 375px;
  position: absolute;
  height: ${(props) => props.clientHeight}px;
  right: 0;
  top: 0;
  background-color: ${colors.background};

  @media (max-width: 1025px) {
    max-width: 100%;
    width: 100%;
  }

  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  @-webkit-keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
`
export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  height: 140px;
  margin-bottom: 5px;
  background-color: ${colors.background};

  @media (max-width: 330px) {
    height: 150px;
  }
`
export const Section = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  @media(max-height: 1000px) {
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 0;
    }

    ::-webkit-scrollbar-track {
      display: none;
    }
  }
`
export const Box = styled.div`
  width: 85%;
  padding: 5px;
  background-color: ${colors.background};
  border-radius: 12px;
  border: 1px solid ${colors.softGray};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 22px;
`
export const Text = styled.p`
  font-size: 14px;
  color: ${colors.strongGray};
`
export const TitleText = styled.p`
  font-size: 16px;
`
export const TextBox = styled.div`
  width: 100%;
  gap: 2px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export const Icon = styled.div`
  background-color: ${colors.softGreen};
  border-radius: 50%;
  padding: 5px;
  margin-right: 5px;
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
`

export const CheckIcon = styled.div`
  color: ${colors.primary};
  font-size: 24px;

`

export const ArrowIcon = styled.div`
  color: ${colors.strongGray};
  font-size: 24px;
`
export const BagIcon = styled.div`
  color: ${colors.strongGray};
  font-size: 24px;
`

export const Line = styled.div`
  width: 85%;
  height: 1px;
  background-color: ${colors.softGray};
  margin: 5px 0;
`
